module.exports = __webpack_public_path__ + "static/desktop-b8a10864be2cd3ea877eceeeabb1d152.gif";